function createFoldSection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec full-fold wf-section sc-bg canBeDeleted">
  <div class="mesa-fold-cont">
    <div class="pad mini-pad">
      <div class="img-wrap full-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
      <div class="cont abs-cont full">
        <div class="pad">
          <div class="flex ver left spaced">
            <div class="cont">
              <h1 id="title-${nmb}" class="hero-par sc-text"></h1>
            </div>
            <div class="cont">
              <div class="flex left ver gap">
                <div id="content-${nmb}" class="big-par sc-text"></div>
                
                  <a id="link-${nmb}" href="" target="_blank" class="btn prim-btn w-button pc-text tc-btn d-none"></a>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>`)
}

function createEventSection(nmb){
  return(`<section class="sec wf-section sc-bg canBeDeleted" nmb="${nmb}" id="section-${nmb}">
  </section>`)
}

function createSmallBannerSection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec alt-txt-color wf-section sc-bg canBeDeleted">
    <div class="pad no-side-pad">
      <div class="cont">
        <div class="cont abs-cont">
          <div class="img-wrap full-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
        </div>
        <div class="cont">
          <div class="pad">
            <div class="cont med-cont">
              <div class="flex ver big-gap">
                <div class="cont"></div>
                <div class="cont narrow-cont">
                  <div class="flex ver left gap">
                    <h2 class="sc-text" id="title-${nmb}"></h2>
                    <div class="sc-text" id="content-${nmb}"></div>
                    
                      <a id="link-${nmb}" href="" target="_blank" class="btn sec-btn w-button pc-text sc-btn d-none"></a>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createBigBannerSection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec wf-section canBeDeleted">
    <div class="mesa-fold-cont">
      <div class="cont abs-cont">
        <div class="cont abs-cont">
          <div class="img-wrap full-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
        </div>
      </div>
      <div class="cont abs-cont">
        <div class="pad big-pad">
          <div class="flex ver cen mid">
            <div class="cont med-cont">
              <div class="flex ver cen mid gap">
                <h1 id="title-${nmb}" class="hero-par sc-text"></h1>
                <div id="content-${nmb}" class="big-par sc-text"></div>
                
                  <a id="link-${nmb}" href="" target="_blank" class="btn prim-btn w-button tc-btn d-none"></a>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createImageLeftBannerSection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec dark-sec wf-section pc-bg canBeDeleted">
    <div class="pad">
      <div class="flex ver big-gap">
        <div class="cont">
          <div>
            <h2 class="cont sc-text" id="title-${nmb}"></h2>
          </div>
        </div>
        <div class="cont">
          <div class="grid two-col">
            <div id="w-node-_6e0ac27e-a903-d136-1c6f-487ed023e109-ff042bfa" class="cont">
              <div class="img-wrap wide-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
            </div>
            <div id="w-node-_6e26809e-9878-dc53-c398-4358a7aa6494-ff042bfa" class="cont">
              <div class="pad small-pad">
                <div class="cont med-cont">
                  <div class="flex ver left gap">
                    <div id="content-${nmb}" class="med-par sc-text"></div>
                    
                      <a id="link-${nmb}" href="" target="_blank" class="btn prim-btn w-button tc-btn d-none"></a>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createImageRightBannerSection(nmb){
  return(`

  <section id="section-${nmb}" nmb="${nmb}" class="sec dark-sec wf-section pc-bg canBeDeleted">
    <div class="pad">
      <div class="flex ver big-gap">
        <div class="cont">
          <div>
            <h2 id="title-${nmb}" class="cont sc-text"></h2>
          </div>
        </div>
        <div class="cont">
          <div class="grid two-col">
            <div id="w-node-_6e26809e-9878-dc53-c398-4358a7aa6494-ff042bfa" class="cont">
              <div class="pad small-pad">
                <div class="cont med-cont">
                  <div class="flex ver left gap">
                    <div id="content-${nmb}" class="med-par sc-text"></div>
                      <a
                        id="link-${nmb}"
                        href="" target="_blank"
                        class="btn prim-btn w-button tc-btn d-none"
                      >
                      </a>
                  </div>
                </div>
              </div>
            </div>
            <div id="w-node-_6e0ac27e-a903-d136-1c6f-487ed023e109-ff042bfa" class="cont">
              <div class="img-wrap wide-img-wrap">
                <img
                  id="image-${nmb}"
                  loading="lazy"
                  src=""
                  alt=""
                  class="cover-img"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  
  `)
}

function createOverBannerSection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec alt-sec wf-section tc-bg canBeDeleted">
    <div class="pad">
      <div class="flex ver gap">
        <div class="cont">
          <div class="img-wrap banner-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
        </div>
        <div class="cont">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen mid small-gap">
                <h2 class="sc-text" id="title-${nmb}"></h2>
                <div class="sc-text" id="content-${nmb}"></div>
                
                  <a id="link-${nmb}" href="" target="_blank" class="btn sec-btn w-button sc-btn d-none"></a>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createBigVideoSection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec wf-section sc-bg canBeDeleted">
    <div class="pad">
      <div class="flex ver gap">
        <div class="cont">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen mid small-gap">
                <h2 class="pc-text" id="title-${nmb}"></h2>
              </div>
            </div>
          </div>
        </div>
        <div class="cont">
          <div class="video-wrap w-video w-embed big">
              <iframe width="966" height="543" id="video-${nmb}" src="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
        </div>
        <div class="cont">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen mid small-gap">
                <div class="pc-text" id="content-${nmb}"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createSmallVideoSection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec dark-sec wf-section pc-bg canBeDeleted">
    <div class="pad">
      <div class="flex ver gap">
        <div class="cont">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen mid small-gap">
                <h2 class="sc-text" id="title-${nmb}"></h2>
              </div>
            </div>
          </div>
        </div>
        <div class="cont">
          <div class="grid four-col bot">
            <div id="w-node-_10366295-560b-1790-9dfd-b0701126ea87-ff042bfa" class="video-wrap w-video w-embed small">
              <iframe width="966" height="543" id="video-${nmb}" src="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
            <div class="cont">
              <div class="sc-text" id="content-${nmb}"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createGridGallerySection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec wf-section sc-bg canBeDeleted">
    <div class="pad">
      <div class="flex ver gap">
        <div class="cont">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen mid small-gap">
                <h2 class="pc-text" id="title-${nmb}"></h2>
                <div class="pc-text" id="content-${nmb}"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="cont">
          <div id="img-container-${nmb}" class="grid three-col">
            
              
            
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createSliderGallerySection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec wf-section sc-bg canBeDeleted">
    <div class="pad">
      <div class="flex ver gap">
        <div class="cont">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen mid small-gap">
                <h2 class="pc-text" id="title-${nmb}"></h2>
                <div class="pc-text" id="content-${nmb}"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="cont">
          <div data-delay="4000" data-animation="slide" class="mesa-slider w-slider" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="500" data-infinite="true">
            <div id="img-container-${nmb}" class="mesa-slider-mask w-slider-mask">
              
                
              
            </div>
            <div class="arrow-wrap w-slider-arrow-left">
              <div class="mesa-slider-icon w-icon-slider-left pc-text"></div>
            </div>
            <div class="arrow-wrap w-slider-arrow-right">
              <div class="mesa-slider-icon w-icon-slider-right pc-text"></div>
            </div>
            <div class="hidden w-slider-nav w-round"></div>
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createListGallerySection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec wf-section sc-bg canBeDeleted">
    <div class="pad">
      <div class="flex ver gap">
        <div class="cont">
          <div class="flex ver cen">
            <div class="cont narrow-cont">
              <div class="flex ver cen mid small-gap">
                <h2 class="pc-text" id="title-${nmb}"></h2>
                <div class="pc-text" id="content-${nmb}"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="cont">
          <div id="img-container-${nmb}" class="flex ver big-gap">
            
              
            
          </div>
        </div>
      </div>
    </div>
  </section>`)
}

function createMapSection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec dark-sec wf-section pc-bg canBeDeleted">
  <div class="pad">
    <div class="flex ver gap">
      <div class="cont">
        <div class="flex ver left">
          <div class="cont">
            <h2 class="sc-text" id="title-${nmb}"></h2>
          </div>
        </div>
      </div>
      <div class="cont">
        <div class="grid three-col">
          <div id="w-node-_714b1344-65b6-cb42-75c7-572ea806871c-ff042bfa" class="cont">
            <div id="ubication-element-container-${nmb}" class="flex ver gap">
            </div>
          </div>
          <div id="w-node-_42baf421-b006-b7da-ec18-7c0cc9a77bc1-ff042bfa" class="cont">
            <div class="img-wrap wide-img-wrap w-widget w-widget-map" id="ubications-${nmb}" data-widget-style="roadmap" data-widget-latlng="" aria-label="" data-enable-scroll="true" role="region" title="" data-enable-touch="true" data-widget-zoom="12" data-widget-tooltip=""></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>`)
}

function createTextSection(nmb){
  return(`<section id="section-${nmb}" nmb="${nmb}" class="sec wf-section sc-bg canBeDeleted">
  <div class="pad big-pad">
    <div class="flex ver gap">
      <div class="cont">
        <div class="flex ver cen">
          <div class="cont med-cont">
            <div class="flex ver cen mid gap">
              <h2 class="pc-text" id="title-${nmb}"></h2>
              <div id="content-${nmb}" class="big-par pc-text"></div>
              
                <a id="link-${nmb}" href="" target="_blank" class="btn prim-btn w-button tc-btn d-none"></a>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>`)
}

function createEventItem(nmb,vestimenta="",fecha="",nombre="",descripcion="",link="",ubicacion=""){
  return(`<div class="pad canBeDeleted ws-Event-${nmb}-0">
      <div class="cont">
        <div class="flex ver cen gap">
          <div class="cont narrow-cont">
            <h2 id="ws-title-val-${nmb}" class="pc-text">${nombre}</h2>
          </div>
          <div class="cont narrow-cont">
            <div id="ws-description-val-${nmb}" class="med-par pc-text">${descripcion}</div>
          </div>
          <div class="cont narrow-cont"></div>
          <div class="cont narrow-cont">
            <div class="flex ver small-gap">
              <div class="mesa-info pc-text">
                <span class="classdate" id="ws-date1-val-${nmb}">${fecha.replace('T', ' ').split(' ')[0].replaceAll('-', ' ')}</span> 
                a las 
                <span class="classdate" id="ws-date2-val-${nmb}">${fecha.replace('T', ' ').split(' ')[1].replace(':00+00:00', ' ')}</span> 
                EN 
                <a href="${link}" id="ws-place-val-${nmb}" target="_blank" class="tc-text">
                  <span id="ws-place-valText-${nmb}">${ubicacion}</span>
                </a>
              </div>
              <div id="ws-outfit-val-${nmb}" class="mesa-info pc-text">${vestimenta}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cont canBeDeleted ws-Event-${nmb}-0">
      <div class="pad mini-pad no-plane-pad">
        <div class="separator pc-bg"></div>
      </div>
    </div>`)
}

function createUbicationItem(nmb,link,ubicacion){
  return(`<div id="section-${nmb}" class="cont canBeDeleted">
            <div class="flex ver left mini-gap">
              <h3 id="title-${nmb}" class="card-title sc-text">${ubicacion}</h3>
              <div id="content-${nmb}" class="sc-text"></div>
              <a href="${link}" id="link-${nmb}" target="_blank" class="btn alt-btn white-txt w-button sc-text">Ver en Google Maps</a>
            </div>
          </div>`)
}

function createGridItem(nmb){
  return(`<div id="section-${nmb}" nmb="${nmb}" class="gall-card canBeDeleted">
            <div class="flex ver small-gap">
              <div class="cont">
                <div class="img-wrap wide-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
              </div>
              <div class="cont">
                <div class="flex ver cen small-gap">
                  <div id="title-${nmb}" class="gall-card-caption"></div>
                  <div id="content-${nmb}" class="small-par"></div>
                  
                    <a id="link-${nmb}" href="" target="_blank" class="btn alt-btn w-button d-none"></a>
                  
                </div>
              </div>
            </div>
          </div>`)
}

function createSliderItem(nmb){
  return(`<div id="section-${nmb}" nmb="${nmb}" class="mesa-slide w-slide canBeDeleted">
            <div class="img-wrap fhd-img-wrap">
              <img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img">
            </div>
          </div>`)
}

function createListItem(nmb){
  return(`<div id="section-${nmb}" nmb="${nmb}" class="gall-card canBeDeleted">
            <div id="w-node-_8b5097d0-1981-486c-61b4-fe02ab552443-ff042bfa" class="grid two-col mid">
              <div id="w-node-_7ae307c7-6bbd-7001-b37f-d1fdd2f96af3-ff042bfa" class="cont">
                <div class="cont">
                  <div class="img-wrap wide-img-wrap"><img id="image-${nmb}" loading="lazy" src="" alt="" class="cover-img"></div>
                </div>
              </div>
              <div id="w-node-_349ab496-8036-eca4-e2c5-ca76a2ee2720-ff042bfa" class="cont">
                <div class="flex ver left spaced big-gap">
                  <div class="cont">
                    <h3 id="title-${nmb}" class="hor-card-title"></h3>
                  </div>
                  <div class="cont">
                    <div class="flex ver left small-gap">
                      <div id="content-${nmb}"></div>
                      
                        <a id="link-${nmb}" href="" target="_blank" class="btn alt-btn w-button d-none"></a>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>`)
}